export default {
  methods: {
    toTitleCase(string) {
      return string.replace(
        /\w\S*/g,
        text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
      );
    },
  },
};
